import React from 'react';
import {
    Button, Image,
    Modal,
    ModalBody,
    ModalContent,
    ModalOverlay, Text,
    useColorMode
} from "@chakra-ui/react";
import useTranslation from "next-translate/useTranslation";


function ContactSuccessModal({isSend, onClose, isOpen, success, error, ...props}) {
    const {t} = useTranslation()
    const {colorMode}=useColorMode();
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay
                bg={'rgba(0, 0, 0, 0.85)'}
                backdropBlur='2px'
            />
            <ModalContent maxW={"439px"}>
                <ModalBody textAlign={"center"} py={'80px'} experimental_spaceY={8}>
                    {success && <Image alt={"success"} mr={"auto"} ml={"auto"} w={"150px"} h={"100px"} src={"/images/contact_success.svg"}/>}
                    {error && <Image alt={"error"} mr={"auto"} ml={"auto"} w={"150px"} h={"100px"} src={"/images/contact_error.svg"}/>}
                    <Text color={colorMode === 'light' ? 'inherit' : 'white'}>
                        {success? success : error}
                    </Text>
                    <Button justifyItems={"center"} w={"300px"} h={"40px"} variant={"outline"} colorScheme={"brand"} bg={"rgba(0, 178, 149, 0.1)"} onClick={onClose}>
                        {t('contact:modal.close')}
                    </Button>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

export default ContactSuccessModal;